<infos-action-card
  label="EstImage Pay"
  [ngClass]="{ 'cursor-pointer': !submitted }"
  (click)="!submitted && useEstimagePay.emit()">
  <mat-icon info-icon class="size-18! text-18! mt-[2px]" svgIcon="estimage_pay" />

  <div info-guidance>
    @if (invoiceApprovedOrAccepted()) {
      @if (paymentFailed()) {
        <span> The request for payment failed. Please contact Support. </span>
      } @else {
        <span class="flex items-center gap-x-10">
          Your request for payment of this invoice is
          <status-chip smallChip [status]="_invoice().estimagePayPaymentRequestStatus" />
        </span>
        @switch (_invoice().estimagePayPaymentRequestStatus) {
          @case ('SUBMITTED') {
            <ng-template
              [ngTemplateOutlet]="subGuidance"
              [ngTemplateOutletContext]="{
                guidance: 'Your payment request has been created and is pending manual review.'
              }" />
          }
          @case ('ACTIVE') {
            <ng-template
              [ngTemplateOutlet]="subGuidance"
              [ngTemplateOutletContext]="{
                guidance:
                  'Your payment request has been approved, disbursement has been created and will be sent shortly.'
              }" />
          }
          @case ('DECLINED') {
            <ng-template
              [ngTemplateOutlet]="subGuidance"
              [ngTemplateOutletContext]="{
                guidance: 'Your payment request was declined and won’t be funded; please contact Support.'
              }" />
          }
          @case ('CANCELLED') {
            <ng-template
              [ngTemplateOutlet]="subGuidance"
              [ngTemplateOutletContext]="{
                guidance: 'Your payment request has been cancelled outside of EstImage by an authorised user.'
              }" />
          }
          @case ('COMPLETED') {
            <ng-template
              [ngTemplateOutlet]="subGuidance"
              [ngTemplateOutletContext]="{ guidance: 'Your payment request has been settled.' }" />
          }
        }
      }
    } @else {
      @if (invoiceRejected()) {
        {{
          ['DELETED_AFTER_INVOICE_APPROVAL'].includes(_invoice().estimagePayPaymentRequestStatus)
            ? 'Your request for payment of this invoice has been cancelled (invoice rejected).'
            : ['FAILED_TO_BE_DELETED'].includes(_invoice().estimagePayPaymentRequestStatus)
              ? 'There was an error cancelling this request for payment on invoice rejection, please contact Support.'
              : 'Your request for payment of this invoice has not been sent (invoice rejected)'
        }}
      } @else {
        @if (totalPayable > _invoice().estimagePayMaxAmount) {
          This invoice cannot be paid through EstImage Pay as the total payable is greater than the maximum amount
          allowed ({{ _invoice().estimagePayMaxAmount | number: '1.2-2' }}$). On submission of the invoice, this request
          for payment will be removed.
        } @else {
          A request for payment will be sent through EstImage Pay on approval of this invoice.
        }
      }
    }
  </div>

  <div
    info-details
    class="grid gap-x-40 gap-y-15"
    [ngClass]="_invoice().estimagePayRequestId ? 'grid-cols-3' : 'grid-cols-2'">
    <ng-template
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{
        field: 'Amount Requested',
        value:
          '$ ' +
          ((_invoice().estimagePayPaymentRequestStatus === 'WAITING_FOR_INVOICE_APPROVAL_TO_SEND_REQUEST'
            ? totalPayable
            : _invoice().estimagePayAmountRequested
          ) | number: '1.2-2')
      }" />
    <ng-template
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{ field: 'Account Name', value: _invoice().estimagePayDisbursementAccountName }" />
    <ng-template
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{ field: 'Payment Request ID', value: _invoice().estimagePayRequestId }" />
    <ng-template
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{ field: 'Account Number', value: _invoice().estimagePayDisbursementAccountNumber }" />
    <ng-template
      [ngTemplateOutlet]="info"
      [ngTemplateOutletContext]="{ field: 'BSB', value: _invoice().estimagePayDisbursementBsb }" />
  </div>

  @if (!submitted) {
    <button matIconButton type="button" delete-icon (click)="$event.stopPropagation(); removeEstImagePay()">
      <mat-icon>delete</mat-icon>
    </button>
  }
</infos-action-card>

<ng-template #info let-field="field" let-value="value">
  @if (value) {
    <infos-content [field]="field" [value]="value" />
  }
</ng-template>

<ng-template #subGuidance let-guidance="guidance">
  <span class="body-2">{{ guidance }}</span>
</ng-template>
